<template>
  <div class="row">
    <div class="col-12">
      <div class="card mb-4 h-100">
        <div class="card-header pb-0">
          <div class="row">
            <div class="col-6">
              <h6 class="mb-0">Rates Setting</h6>
            </div>
          </div>
        </div>
        <hr class="mx-3" style="border-top: 1px solid !important" />

        <div class="row">
          <div class="col">
            <div class="d-flex flex-wrap ps-3">
              <div class="card-new position-relative card-rate">
                <div class="upper-section">
                  <div class="d-flex align-items-center mb-3">
                    <img src="/img/masterdealer.png" alt="logo" />
                  </div>
                </div>
                <div class="body-section mb-3">
                  <div class="card-rate-setting">
                    <p class="mb-1 fw-bold">Rebate</p>
                    <p class="mb-0 text-muted">Dealer</p>
                  </div>
                  <hr class="bg-dark w-100" />
                  <input type="number" class="form-control input-rate"
                    :value="rateSetting.rebate === 0 ? '' : rateSetting.rebate"
                    @input="rateSetting.rebate = $event.target.value === '' ? 0 : parseFloat($event.target.value)"
                    :disabled="submitting" />
                  <span> %</span>
                </div>
                <div class="body-section mb-3 mt-4">
                  <div class="card-rate-setting">
                    <p class="mb-1 fw-bold">Discount</p>
                    <p class="mb-0 text-muted">Sub Retailer User</p>
                  </div>
                  <hr class="bg-dark w-100" />
                  <input type="number" class="form-control input-discount"
                    :value="rateSetting.discount === 0 ? '' : rateSetting.discount"
                    @input="rateSetting.discount = $event.target.value === '' ? 0 : parseFloat($event.target.value)"
                    :disabled="submitting" />
                  <span class="span2"> %</span>
                </div>
                <div>
                  <button type="button" class="btn bg-violet text-white w-100 mt-4 mb-0" :disabled="submitting"
                    @click="submitSmartRate">
                    <div v-if="submitting" class="spinner-border spinner-border-sm" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    Submit
                  </button>
                </div>
              </div>

              <div class="card-new card-bayad position-relative card-rate">
                <div class="upper-section">
                  <div class="d-flex align-items-center mb-3">
                    <img src="/img/bayad_logo.png" alt="logo" />
                  </div>
                </div>
                <div class="mb-3 mt-5">
                  <p class="mb-1 fw-bold">Convenience Fee</p>
                  <hr class="bg-dark w-100"  style="position: absolute; z-index:-2;width: 200px !important;"/>
                  <div class="d-flex align-items-center">
                  <input type="number" class="form-control input-rate-php"
                    style="width: 300px;margin-left: 200px;"
                    :value="bayadRateSetting.convenienceFee === 0 ? '' : bayadRateSetting.convenienceFee"
                    @input="bayadRateSetting.convenienceFee = $event.target.value === '' ? 0 : parseFloat($event.target.value)"
                    :disabled="bayadSubmitting" />
                  <p class="mb-0 ms-3" style="z-index: 999;">Php</p>
                  </div>
                </div>
                <!-- <div class="body-section mb-3 mt-4">
                  <div class="card-rate-setting">
                    <p class="mb-1 fw-bold">Discount</p>
                    <p class="mb-0 text-muted">Sub Retailer User</p>
                  </div>
                  <hr class="bg-dark w-100" />
                  <input type="number" class="form-control input-discount"
                    :value="bayadRateSetting.discount === 0 ? '' : bayadRateSetting.discount"
                    @input="bayadRateSetting.discount = $event.target.value === '' ? 0 : parseFloat($event.target.value)"
                    :disabled="bayadSubmitting" />
                  <span class="span2"> %</span>
                </div> -->
                <div style="margin-top: 75px;">
                  <button type="button" class="btn bg-violet text-white w-100 mt-3 mb-0" :disabled="bayadSubmitting"
                    @click="submitBayadRate">
                    <div v-if="bayadSubmitting" class="spinner-border spinner-border-sm" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <GlobalModal :show="modal.show" :title="modal.title" :message="modal.message" :type="modal.type"
    @confirm="modal.onConfirm" @cancel="modal.onCancel" @close="modal.show = false" />

</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import GlobalModal from "@/components/GlobalModal.vue";
export default {
  data() {
    return {
      modal: { show: false, type: 'success', title: '', message: '' }
    };
  },
  components: {
    GlobalModal
  },
  computed: {
    ...mapState({
      submitting: (state) => state.adminController.submitting,
      bayadSubmitting: (state) => state.adminController.bayadSubmitting,
      rateSetting: (state) => state.adminController.rateSetting,
      bayadRateSetting: (state) => state.adminController.bayadRateSetting,
    }),
  },
  methods: {
    ...mapActions({
      addRateSettings: "adminController/AddRateSettings",
      addBayadRateSettings: "adminController/AddBayadRateSettings",
      getSmartRateSetting: "adminController/GetSmartRateSetting",
      getBayadRateSetting: "adminController/GetBayadRateSetting",
    }),

    async submitSmartRate() {
      this.rateSetting.type = "SMART";

      if (this.rateSetting != null) {
        const confirmed = await this.showModal(
          'confirmation',
          'You are about to set rate to SMART.',
          'Press Confirm to proceed or Cancel to abort.'
        );

        if (confirmed) {
          try {
            const result = await this.addRateSettings();
            if (result) {
              this.showModal(
                'success',
                `Rate for ${this.rateSetting.type} successfully added.`,
              );
            } else {
              this.showModal(
                'error',
                `Failed to add rate for ${this.rateSetting.type}.`,
              );
            }
          } catch (error) {
            this.showModal(
              'error',
              `An error occurred while adding rate.`,
            );
          }
        }
      }
    },

    async submitBayadRate() {
      this.bayadRateSetting.type = "BAYAD";

      if (this.bayadRateSetting != null) {
        const confirmed = await this.showModal(
          'confirmation',
          'You are about to set rate to BAYAD.',
          'Press Confirm to proceed or Cancel to abort.'
        );

        if (confirmed) {
          try {
            const result = await this.addBayadRateSettings();
            if (result) {
              this.showModal(
                'success',
                `Rate for ${this.bayadRateSetting.type} successfully added.`,
              );

            } else {
              this.showModal(
                'error',
                `Failed to add rate for ${this.bayadRateSetting.type}.`,
              );
            }
          } catch (error) {
            this.showModal(
              'error',
              `An error occurred while adding rate.`,
            );
          }
        }
      }
    },
    showModal(type, title, message) {
      return new Promise((resolve) => {
        this.modal = {
          show: true,
          type,
          title,
          message,
          // Bind these so GlobalModal can trigger them
          onConfirm: () => {
            this.modal.show = false;
            resolve(true);
          },
          onCancel: () => {
            this.modal.show = false;
            resolve(false);
          },
          close: () => {
            this.modal.show = false;
            resolve(false);
          },
        };
      });
    }

  },
  async mounted() {
    await this.getSmartRateSetting();
    await this.getBayadRateSetting();
  },
};
</script>

<style scoped>
.input-discount {
  bottom: 85px !important;
  width: 280px;
  right: 10px;
  margin-right: 30px;
}

.input-rate {
  position: absolute;
  width: 280px;
  right: 10px;
  top: 120px;
  margin-right: 30px;
}

.card-new>.body-section span {
  font-size: 16px;
  position: absolute;
  right: 0;
  top: 130px;
  width: 40px;
  text-align: center;
  background-color: white;
}

.card-new>.body-section .span2 {
  font-size: 16px;
  position: absolute;
  right: 0;
  top: 220px;
  width: 40px;
  text-align: center;
  background-color: white;
}
.card-bayad{
  height: 335px !important;
}
</style>
